AFRAME.registerComponent('profile-tab', {
    schema: {
        companyName: { type: 'string', default: '' },
        companyLogo: { type: 'string', default: '' },
        ticker: { type: 'string', default: '' },
        description: { type: 'string', default: '' },
        address: { type: 'string', default: '' },
        sector: { type: 'string', default: '' },
        industry: { type: 'string', default: '' },
        sectorId: { type: 'number', default: 0 },
        employees: { type: 'number', default: null },
        employeesNumber: { type: 'string', default: '' },
        exchange: { type: 'string', default: '' },
        type: { type: 'string', default: '' },
    },

    init: function () {
        console.log('profile-tab: Initializing with data:', this.data);

        this.themeMode = 'Dark';
        try {
            const mainSettings = getCacheItem('mainSettings');
            if (mainSettings && mainSettings.themeMode) {
                this.themeMode = mainSettings.themeMode;
            }
        } catch (e) {
            console.warn('profile-tab: Failed to load theme settings', e);
        }

        window.addEventListener('theme-changed', (e) => {
            if (e.detail && e.detail.themeMode) {
                this.themeMode = e.detail.themeMode;
                Array.from(this.el.children).forEach(child => {
                    if (!child.classList.contains('no-stock-selected-message')) {
                        this.el.removeChild(child);
                    }
                });
                this.createContent();
                this.updateStockSelectionState();
            }
        });

        this.noStockMessage = this.el.querySelector('.no-stock-selected-message');
        this.updateStockSelectionState();
        this.createContent();

        this.el.addEventListener('profile-data-updated', (event) => {
            console.log('profile-tab: Received profile-data-updated event', event.detail);
            if (event.detail) {
                Object.keys(event.detail).forEach(key => {
                    this.data[key] = event.detail[key];
                });
            }
            this.updateStockSelectionState();
            Array.from(this.el.children).forEach(child => {
                if (!child.classList.contains('no-stock-selected-message')) {
                    this.el.removeChild(child);
                }
            });
            this.createContent();
            this.updateStockSelectionState();
        });
    },

    update: function (oldData) {
        console.log('profile-tab: Update called', {
            hasOldData: !!oldData,
            oldDataKeys: oldData ? Object.keys(oldData) : [],
            newData: this.data
        });

        if (!oldData || Object.keys(oldData).length === 0) {
            console.log('profile-tab: Initial update, skipping');
            return;
        }
        const fieldsToCheck = [
            'companyName', 'companyLogo', 'ticker', 'description',
            'address', 'sector', 'industry', 'sectorId',
            'employees', 'employeesNumber', 'exchange', 'type'
        ];

        let hasChanges = false;
        const changes = {};

        fieldsToCheck.forEach(key => {
            const newVal = this.data[key];
            const oldVal = oldData[key];

            const normalize = (val) => {
                if (val === null || val === undefined) return '';
                if (typeof val === 'number') return String(val);
                return String(val).trim();
            };

            const newValNorm = normalize(newVal);
            const oldValNorm = normalize(oldVal);

            if (newValNorm !== oldValNorm) {
                hasChanges = true;
                changes[key] = { old: oldVal, new: newVal };
            }
        });

        if (hasChanges) {
            console.log('profile-tab: Data changed, updating content', {
                changes: changes,
                oldData: oldData,
                newData: this.data
            });
            this.updateStockSelectionState();
            Array.from(this.el.children).forEach(child => {
                if (!child.classList.contains('no-stock-selected-message')) {
                    this.el.removeChild(child);
                }
            });
            this.createContent();
            this.updateStockSelectionState();
        } else {
            console.log('profile-tab: No changes detected', {
                oldData: oldData,
                newData: this.data
            });
            this.updateStockSelectionState();
        }
    },

    createContent: function () {
        const self = this;
        const url = this.data.companyLogo;
        const isRealUrl = url && url !== '#company-logo-temp' && url !== '' && !url.startsWith('#');

        if (isRealUrl) {
            const tester = new Image();
            tester.onload = () => self._renderContent(true);
            tester.onerror = () => self._renderContent(false);
            tester.src = url;
        } else {
            this._renderContent(false);
        }
    },

    _renderContent: function (hasLogo) {
        const self = this;
        const textColor = this.themeMode === 'Light' ? '#14141C' : '#FFFFFF';
        const isLight = this.themeMode === 'Light';
        const labelColor = isLight ? '#8C8C8C' : '#FFFFFF';
        const labelOpacity = isLight ? '1' : '0.5';
        const mainBlock = document.createElement('a-entity');
        mainBlock.classList.add('main-info-block');
        this.el.appendChild(mainBlock)

        if (hasLogo) {
            const logo = document.createElement('a-image');
            logo.setAttribute('src', this.data.companyLogo);
            logo.setAttribute('width', 0.04);
            logo.setAttribute('height', 0.04);
            logo.setAttribute('transparent', true);
            logo.setAttribute('material', 'alphaTest: 0.1');
            logo.setAttribute('position', `-0.075 -0.03 0`)
            mainBlock.appendChild(logo)
        }

        const companyNameText = this.data.companyName || '';
        const truncatedCompanyName = companyNameText.length > 70
            ? companyNameText.slice(0, companyNameText.lastIndexOf(' ', 70)) + "..."
            : companyNameText;

        const companyName = document.createElement('a-text');
        companyName.setAttribute('value', truncatedCompanyName);
        // title.setAttribute('font-size', 0.05);
        companyName.setAttribute('scale', '0.05 0.05 0.05');
        companyName.setAttribute('force-color-update', '');
        companyName.setAttribute('color', textColor);
        companyName.setAttribute('anchor', 'left');
        companyName.setAttribute('position', `${hasLogo ? -0.04 : -0.075} -0.03 0`)
        companyName.setAttribute('width', 3)
        companyName.setAttribute('wrap-count', 24)
        companyName.setAttribute('line-height', 60)
        mainBlock.appendChild(companyName);

        const tickerContainer = document.createElement('a-entity');
        tickerContainer.classList.add('ticker-block');
        tickerContainer.setAttribute('position', `0 -0.08 0`)
        this.el.appendChild(tickerContainer)

        const tickerLabel = document.createElement('a-text');
        tickerLabel.setAttribute('value', 'Ticker');
        tickerLabel.setAttribute('scale', '0.05 0.05 0.05');
        tickerLabel.setAttribute('opacity', labelOpacity);
        tickerLabel.setAttribute('color', labelColor);
        tickerLabel.setAttribute('anchor', 'left');
        tickerLabel.setAttribute('position', '-0.1 0 0');
        tickerContainer.appendChild(tickerLabel);

        const tickerValue = document.createElement('a-text');
        tickerValue.setAttribute('value', this.data.ticker);
        tickerValue.setAttribute('scale', '0.05 0.05 0.05');
        tickerValue.setAttribute('color', textColor);
        tickerValue.setAttribute('anchor', 'left');
        tickerValue.setAttribute('position', `-0.06 0 0`);
        tickerContainer.appendChild(tickerValue);

        const description = this.data.description || 'N/A';
        const truncatedDescription = description !== 'N/A' && description.length > 80
            ? description.slice(0, description.lastIndexOf(' ', 80)) + "..."
            : description;
        const address = this.data.address || 'N/A';
        const truncatedAddress = address !== 'N/A' && address.length > 70
            ? address.slice(0, address.lastIndexOf(' ', 70)) + "..."
            : address;
        let employeesText = this.data.employeesNumber;
        if (this.data.employees !== null && this.data.employees !== undefined) {
            employeesText = `Approximately ${this.data.employees.toLocaleString()}`;
        }
        createStandardTextBlock('Description', truncatedDescription, -0.09);
        createStandardTextBlock('Address', truncatedAddress, -0.16);
        createStandardTextBlock('# of employees', employeesText || 'N/A', -0.25);
        createStandardTextBlock('Exchange', this.data.exchange || 'N/A', -0.285);
        createStandardTextBlock('Type', this.data.type || 'N/A', -0.32);

        const segmentsList = [
            { id: 1, name: 'Utilities', iconName: '#utilities-icon', color: '#00C4B3' },
            { id: 2, name: 'Energy', iconName: '#energy-icon', color: '#ACACAC' },
            { id: 3, name: 'Materials', iconName: '#materials-icon', color: '#697AB6', },
            { id: 4, name: 'Financials', iconName: '#financials-icon', color: '#C8C8C8' },
            { id: 5, name: 'Health Care', iconName: '#health-care-icon', color: '#E54360', },
            { id: 6, name: 'Real Estate', iconName: '#real-estate-icon', color: '#CAD1EA', },
            { id: 7, name: 'Information Technology', iconName: '#information-technology-icon', color: '#00945E' },
            { id: 8, name: 'Industrials', iconName: '#industrials-icon', color: '#3636E3', },
            { id: 9, name: 'Communication Services', iconName: '#communication-services-icon', color: '#697AB6', },
            { id: 10, name: 'Consumer Staples', iconName: '#consumer-staples-icon', color: '#F18A00', },
            { id: 11, name: 'Consumer Discretionary', iconName: '#customer-discretionary-icon', color: '#FFC629', },
        ];

        const normalizeSectorName = (sectorName) => {
            if (!sectorName) return '';
            const normalized = sectorName.trim();
            const lowerSector = normalized.toLowerCase();
            if (lowerSector.includes('healthcare') || lowerSector.includes('health care')) {
                return 'Health Care';
            }
            if (lowerSector.includes('basic materials') || (lowerSector.includes('materials') && !lowerSector.includes('information'))) {
                return 'Materials';
            }
            if (lowerSector.includes('technology') || lowerSector.includes('information')) {
                return 'Information Technology';
            }
            if (lowerSector.includes('utilities')) {
                return 'Utilities';
            }
            if (lowerSector.includes('energy')) {
                return 'Energy';
            }
            if (lowerSector.includes('financial')) {
                return 'Financials';
            }
            if (lowerSector.includes('real estate')) {
                return 'Real Estate';
            }
            if (lowerSector.includes('industrial')) {
                return 'Industrials';
            }
            if (lowerSector.includes('communication')) {
                return 'Communication Services';
            }
            if (lowerSector.includes('consumer staples') || lowerSector.includes('consumer defensive')) {
                return 'Consumer Staples';
            }
            if (lowerSector.includes('consumer discretionary') || lowerSector.includes('consumer cyclical') || lowerSector.includes('customer discretionary')) {
                return 'Consumer Discretionary';
            }
            return normalized;
        };

        let sectorData = null;
        if (this.data.sector) {
            const normalizedSectorName = normalizeSectorName(this.data.sector);
            sectorData = segmentsList.find(segment =>
                segment.name.toLowerCase() === normalizedSectorName.toLowerCase()
            );
            if (!sectorData) {
                sectorData = segmentsList.find(segment => {
                    const segmentNameLower = segment.name.toLowerCase();
                    const normalizedLower = normalizedSectorName.toLowerCase();
                    return segmentNameLower === normalizedLower ||
                        segmentNameLower.includes(normalizedLower) ||
                        normalizedLower.includes(segmentNameLower);
                });
            }
            if (!sectorData && this.data.sectorId) {
                sectorData = segmentsList.find(segment => segment.id === self.data.sectorId);
            }
        } else if (this.data.sectorId) {
            sectorData = segmentsList.find(segment => segment.id === self.data.sectorId);
        }

        const sectorContainer = document.createElement('a-entity');
        sectorContainer.classList.add('sector-block');
        sectorContainer.setAttribute('position', `0 -0.22 0`)
        this.el.appendChild(sectorContainer)

        const sectorLabel = document.createElement('a-text');
        sectorLabel.setAttribute('value', 'Sector');
        sectorLabel.setAttribute('scale', '0.05 0.05 0.05');
        sectorLabel.setAttribute('opacity', labelOpacity);
        sectorLabel.setAttribute('color', labelColor);
        sectorLabel.setAttribute('anchor', 'left');
        sectorLabel.setAttribute('position', '-0.1 0 0');
        sectorContainer.appendChild(sectorLabel);

        let sectorName = 'Unknown';
        if (sectorData) {
            sectorName = sectorData.name;
        } else if (this.data.sector) {
            const normalizedSectorName = normalizeSectorName(this.data.sector);
            sectorName = normalizedSectorName || this.data.sector;
        }

        const truncatedSectorName = sectorName.length > 70
            ? sectorName.slice(0, sectorName.lastIndexOf(' ', 70)) + "..."
            : sectorName;

        const sectorValue = document.createElement('a-text');
        sectorValue.setAttribute('value', truncatedSectorName);
        sectorValue.setAttribute('scale', '0.05 0.05 0.05');
        sectorValue.setAttribute('color', textColor);
        sectorValue.setAttribute('anchor', 'left');
        sectorValue.setAttribute('width', 4.5)
        sectorValue.setAttribute('wrap-count', 36)
        sectorValue.setAttribute('line-height', 60)
        sectorValue.setAttribute('position', `-0.03 0 0`);
        sectorContainer.appendChild(sectorValue);

        if (sectorData) {
            const sectorLogo = document.createElement('a-image');
            sectorLogo.setAttribute('src', sectorData.iconName);
            sectorLogo.setAttribute('width', 0.02);
            sectorLogo.setAttribute('height', 0.02);
            sectorLogo.setAttribute('transparent', true);
            sectorLogo.setAttribute('position', `-0.045 0 0`)
            sectorContainer.appendChild(sectorLogo)
        }

        function createStandardTextBlock(labelText, valueText, positionY) {
            const container = document.createElement('a-entity');
            container.classList.add('standard-block');
            container.setAttribute('position', `0 ${positionY} 0`)
            self.el.appendChild(container)

            const label = document.createElement('a-text');
            label.setAttribute('value', labelText);
            label.setAttribute('scale', '0.05 0.05 0.05');
            label.setAttribute('opacity', labelOpacity);
            label.setAttribute('color', labelColor);
            label.setAttribute('anchor', 'left');
            label.setAttribute('position', '-0.1 0 0');
            container.appendChild(label);

            const value = document.createElement('a-text');
            value.setAttribute('value', valueText);
            value.setAttribute('scale', '0.05 0.05 0.05');
            value.setAttribute('color', textColor);
            value.setAttribute('anchor', 'left');
            value.setAttribute('baseline', 'top');
            value.setAttribute('width', 4.5)
            value.setAttribute('wrap-count', 36)
            value.setAttribute('line-height', 60)
            value.setAttribute('position', `-0.1 -0.012 0`);
            container.appendChild(value);
        }

    },

    updateStockSelectionState: function () {
        let hasStock = false;
        const rightPanelDataHandler = document.querySelector('[right-panel-data-handler]');
        if (rightPanelDataHandler && rightPanelDataHandler.components && rightPanelDataHandler.components['right-panel-data-handler']) {
            const ticker = rightPanelDataHandler.components['right-panel-data-handler'].currentTicker;
            hasStock = !!ticker;
        }

        if (!hasStock && this.data.ticker) {
            hasStock = this.data.ticker.trim() !== '' &&
                this.data.ticker !== this.schema.ticker.default;
        }

        if (this.noStockMessage) {
            this.noStockMessage.setAttribute('visible', !hasStock);
            
            const isLight = this.themeMode === 'Light';
            const msgColor = isLight ? '#14141C' : '#fff';
            
            if (this.noStockMessage.tagName.toLowerCase() === 'a-text') {
                this.noStockMessage.setAttribute('color', msgColor);
            } else {
                const textEl = this.noStockMessage.querySelector('a-text');
                if (textEl) textEl.setAttribute('color', msgColor);
                
                const bgEl = this.noStockMessage.querySelector('a-rounded-plane');
                if (bgEl) bgEl.setAttribute('color', isLight ? '#eee' : '#222');
            }
        }

        const contentElements = this.el.querySelectorAll('.main-info-block, .ticker-block, .standard-block, .sector-block');
        contentElements.forEach(el => {
            if (el && el !== this.noStockMessage) {
                el.setAttribute('visible', hasStock);
            }
        });
    }
})
